module.exports = {
  socketIo: "https://api2.rechart.eu",
  playerkey: "SDFJIWR3sssdgwwerweWLK23423424!sldkfj9s49g499g4cccf",
  debug: true
};
